import {alpha, type Theme, type Components} from "../..";
import {segmentControlButtonClasses} from "../../../components/SegmentControlButton";

type SegmentControlOverrides = Components<Theme>["MuiSegmentControl"];

declare module "@atg-ui/toolkit/components/SegmentControl" {
    interface SegmentControlProps {
        /**
         * If `true`, the SegmentControl will "invert" its color scheme.
         * For use on backgrounds that need higher contrast.
         */
        inverted?: boolean;
    }
}

const overrides: SegmentControlOverrides = {
    styleOverrides: {
        root: ({theme}) => ({
            borderRadius: theme.borderRadius.full,
            gap: theme.spacing(),
            backgroundColor: alpha("#9EAEBD", 0.2),
        }),
    },
    defaultProps: {},
    variants: [
        {
            props: {inverted: true},
            style: ({theme}) => ({
                backgroundColor: theme.color.text.default,

                [`& .${segmentControlButtonClasses.root}:not(.${segmentControlButtonClasses.checked}):hover .${segmentControlButtonClasses.label}`]:
                    {
                        color: theme.color.text.inverted.default,
                    },
                [`& .${segmentControlButtonClasses.root}:not(.${segmentControlButtonClasses.checked}) .${segmentControlButtonClasses.label}`]:
                    {
                        color: theme.color.text.inverted.subtle,
                    },
            }),
        },
    ],
};

export default overrides;
